import { render, staticRenderFns } from "./ManterFuncoesView.vue?vue&type=template&id=e5cf3174"
import script from "./ManterFuncoesView.vue?vue&type=script&lang=js"
export * from "./ManterFuncoesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports